<template>
  <div class="nav">
      <!-- <div class="img1">
        <img class="skull" src="@/assets/logo.png" alt="">
      </div> -->
      <!-- <div class="menu">
        <li><a class="white--text" href="#personInfo" @click="selvPersonInfo">Per-Info</a></li>
        <li><a class="white--text" href="#infoOther"  @click="selvInfoOther">infoOther</a></li>
        <li><a class="white--text" href="#skins" @click="selvskills">Skills</a></li>
        <li><a class="white--text" href="#Proyectos" @click="selvProyectos">Proyectos</a></li>
        <li class="all"><a class="black--text" href="#personInfo" @click="allInfo">All</a></li>
      </div> -->

      <b-navbar id="navbar" class="container-fluid border border-dark justify-content-between" toggleable="md" type="dark" variant="success" >
        <b-navbar-brand class="linkDow px-5" href="NewCurriculumDavidArtero5.pdf" dowload>
        <i class="fas fa-file-download"></i>
        </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" class="bg-dark"></b-navbar-toggle>
        <b-collapse id="nav-collapse" class="justify-content-center" is-nav>
          <b-navbar-nav class="navbarNav">
            <b-nav-item class="navText col p-2 mx-0" href="#personInfo" @click="selvPersonInfo">PerInfo</b-nav-item>
            <b-nav-item class="navText col p-2" href="#infoOther"  @click="selvInfoOther">infoOther</b-nav-item>
            <b-nav-item class="navText col p-2" href="#skins" @click="selvskills">Skills</b-nav-item>
            <b-nav-item class="navText col p-2" href="#Proyectos" @click="selvProyectos">Proyectos</b-nav-item>
            <b-nav-item class="navText col p-2" href="#personInfo" @click="allInfo">All</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <!-- <v-app-bar
      src="@/assets/img/fondoMapa.jpg"
      sm="1"
    >
      <v-menu
        light
        color="primary"
      >

        <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon icon v-on="on"></v-app-bar-nav-icon>
        </template>

        <v-list-item-content>
            <v-list-item-title>personInfo</v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
            <v-list-item-title>infoOther</v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
            <v-list-item-title>skins</v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
            <v-list-item-title>Proyectos</v-list-item-title>
        </v-list-item-content>  
      </v-menu>

      <v-toolbar-title >Page title</v-toolbar-title>

    </v-app-bar> -->
      <!-- <div class="img2">
        <img class="timon" src="@/assets/img/murray.png" alt="">
      </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import {mapState, mapMutations} from 'vuex'
export default {
  computed: {
    ...mapState(['vPersonInfo','vInfoOther','vSkills', 'vProyectos'])
  },

  methods: {
    ...mapMutations(['selvPersonInfo','selvInfoOther','selvskills','selvProyectos', 'allInfo']),
    onClick() {
      axios({
            url: 'http://localhost:8080/src/assets/dowloads/NewCurriculumDavidArtero5.pdf',
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'NewCurriculumDavidArtero5.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
      });
    }
  },
}
</script>

<style scoped>
.navText {
  font-size: 1em;
  font-weight: bold;
  transition: 1s;
}

.navText:hover {
  background-color: black;
  font-size: 1.1em;
  color: yellow;
}

.linkDow {
  font-size: 1.5em;
}

.linkDow:hover {
  font-size: 1.5em;
  background-color: black;
}
</style>